export const iconFontAwesomeDesignCrosshairs = (
	<i className="fa-solid fa-crosshairs"></i>
);
